import cn from 'classnames';
import { useCustomerAddress } from 'hooks';
import { useRouter } from 'next/router';
import styles from './addressCard.module.scss';

const AddressCard = ({
  address,
  addressbookaccountpage,
  isDefaultAddress,
  customer,
  mainAddressPointer,
  setUpdateAddress,
  setUpdateToggleForm,
  setToggleDeleteAddress,
}) => {
  const {
    defaultAddressContent,
    makeDefaultAddressContent,
    editButtonContent,
    deleteButtonContent,
  } = addressbookaccountpage;
  const [{ updateDefaultAddress }, { error }] = useCustomerAddress();
  const { company, address1, address2, city, country, zip, phone } = address;
  const { locale } = useRouter();

  return (
    <div className={styles.addressCardContainer}>
      <>
        {isDefaultAddress ? (
          <div className={styles.inputContainer}>
            {/* <div> */}
            <label htmlFor="defaultAddress" className={styles.label}>
              <input type="radio" name="defaultAddress" checked />
              {defaultAddressContent?.text}
            </label>
            <div>
              <button
                className={styles.editButton}
                onClick={() => {
                  setUpdateAddress(address);
                  setUpdateToggleForm(true);
                }}
                type="button"
              >
                {editButtonContent?.text}
              </button>
              <button
                className={styles.deleteButton}
                onClick={() => {
                  setUpdateAddress(address);
                  setToggleDeleteAddress(true);
                }}
                type="button"
              >
                {deleteButtonContent?.text}
              </button>
            </div>
          </div>
        ) : (
          <div className={cn(styles.inputContainer, styles.addMargin)}>
            <div>
              <label htmlFor="address" className={styles.label}>
                <input
                  type="radio"
                  name="address"
                  onChange={() => updateDefaultAddress(customer.customerAccessToken, address.id)}
                />{' '}
                {makeDefaultAddressContent?.text}
              </label>
            </div>
            <div>
              <button
                className={styles.editButton}
                onClick={() => {
                  setUpdateAddress(address);
                  setUpdateToggleForm(true);
                }}
                type="button"
              >
                {editButtonContent?.text}
              </button>
              <button
                className={styles.deleteButton}
                onClick={() => {
                  setUpdateAddress(address);
                  setToggleDeleteAddress(true);
                }}
                type="button"
              >
                {deleteButtonContent?.text}
              </button>
            </div>
          </div>
        )}

        <ul className={styles.companyDetails}>
          {isDefaultAddress && <li>{mainAddressPointer?.text}:</li>}
          {company && <li>{company}</li>}
          {(address1 || address2) && (
            <li>
              {locale === 'nl'
                ? `${address.address1} ${address.address2}`
                : `${address.address2} ${address.address1}`}
            </li>
          )}
          {(zip || city) && (
            <li>
              {zip} {city}
            </li>
          )}
          {country && <li>{country}</li>}
          {phone && <li>Phone: {phone}</li>}
        </ul>
        {error && <span>{error}</span>}
      </>
    </div>
  );
};

export default AddressCard;
